module.exports = __webpack_public_path__ + "static/media/Kids playhouse 2.78f8a575.jpg";